function getBlockchainUrl(coin) {
  if (process.env.VUE_APP_TESTNET === "true") {
    switch (coin) {
      case "BTC":
        return "https://www.blockchain.com/btc-testnet/";
      case "ETH":
        return "https://sepolia.etherscan.io/";
      case "USDT":
        return "https://sepolia.etherscan.io/";
    }
  } else {
    switch (coin) {
      case "BTC":
        return "https://www.blockchain.com/btc/";
      case "ETH":
        return "https://etherscan.io/";
      case "USDT":
        return "https://etherscan.io/";
    }
  }
  return "";
}

function getTronScanUrl() {
  if (process.env.VUE_APP_TESTNET === "true") {
    return "https://shasta.tronscan.org";
  } else {
    return "https://tronscan.org";
  }
}

export function verifyAddress(address, coin, network) {
  if (network === "trx") {
    let url = getTronScanUrl();
    return `${url}/#address/${address}`;
  }
  if (coin === "BTC") {
    let url = getBlockchainUrl(coin);
    return `${url}address/${address}`;
  } else if (coin === "ADA") {
    return `${process.env.VUE_APP_CARDANO_EXPLORER_URL}address/${address}`;
  } else if (coin === "XLM") {
    return `${process.env.VUE_APP_STELLAR_EXPLORER_URL}account/${address}`;
  } else if (coin === "XRP") {
    return `${process.env.VUE_APP_RIPPLE_EXPLORER_URL}${address}`;
  } else if (coin === "ETH") {
    let url = getBlockchainUrl(coin);
    return `${url}address/${address}`;
  } else if (coin === "USDT") {
    let url = getBlockchainUrl(coin);
    return `${url}address/${address}`;
  }
}

export function verifyTransaction(hash, coin, network) {
  if (network === "trx") {
    let url = getTronScanUrl();
    return `${url}/#transaction/${hash}`;
  }
  if (coin === "BTC") {
    let url = getBlockchainUrl(coin);
    return `${url}tx/${hash}`;
  } else if (coin === "ADA") {
    return `${process.env.VUE_APP_CARDANO_EXPLORER_URL}tx/${hash}`;
  } else if (coin === "XLM") {
    return `${process.env.VUE_APP_STELLAR_EXPLORER_URL}tx/${hash}`;
  } else if (coin === "XRP") {
    return `${process.env.VUE_APP_RIPPLE_EXPLORER_TX_URL}${hash}`;
  } else if (coin === "ETH") {
    let url = getBlockchainUrl(coin);
    return `${url}tx/${hash}`;
  } else if (coin === "USDT") {
    let url = getBlockchainUrl(coin);
    return `${url}tx/${hash}`;
  }
}

export function showCryptoAmount(amount, coin) {
  if (!amount) {
    return 0;
  }
  coin = coin.toUpperCase();
  if (coin === "BTC") {
    return amount / 10 ** 8;
  } else if (coin === "ETH") {
    return amount / 10 ** 18;
  } else if (coin === "ADA") {
    return formatDisplayNumber(amount / 10 ** 6);
  } else if (coin === "XRP") {
    return formatDisplayNumber(amount / 10 ** 6);
  } else if (coin === "TRX") {
    return formatDisplayNumber(amount / 10 ** 6);
  } else if (coin === "USDT") {
    return formatDisplayNumber(amount / 10 ** 6);
  } else {
    return amount;
  }
}

export function showCryptoAmountFee(amount, network) {
  if (!amount) {
    return 0;
  }
  network = network.toUpperCase();
  if (network === "BTC") {
    return (amount / 10 ** 8).toFixed(6);
  } else if (network === "ETH") {
    // Limit show 6 decimal places
    return (amount / 10 ** 18).toFixed(6);
  } else if (network === "ADA") {
    return formatDisplayNumber(amount / 10 ** 6);
  } else if (network === "XRP") {
    return formatDisplayNumber(amount / 10 ** 6);
  } else if (network === "TRX") {
    return formatDisplayNumber(amount / 10 ** 6);
  } else {
    return amount;
  }
}

export function formatDisplayNumber(value, currency) {
  if (value != null) {
    if (currency != null && currency === "JPY") {
      return new Intl.NumberFormat("ja-JP", {
        style: "currency",
        currency: "JPY"
      }).format(value);
    } else {
      return new Intl.NumberFormat().format(value);
    }
  } else {
    return "0";
  }
}

export function formatEllipsisAddress(address) {
  return (
      address.substring(0, 10) + "..." + address.substring(address.length - 10)
  );
}

export function getColorByNetwork(network) {
  switch (network) {
    case "trx":
      return "red";
    case "eth":
      return "blue";
    default:
      return "";
  }
}
